import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=5fc10fdd&scoped=true&%3Akey=componentKey&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc10fdd",
  null
  
)

export default component.exports